"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _two.default
  },
  data: function data() {
    return {
      baseURL: this.config.BASE_URL,
      mine_id: this.$route.query.mine_id || '',
      form: {}
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getInfo();
  },
  methods: {
    /**
     * 获取商户信息
     */
    getInfo: function getInfo() {
      var _this = this;
      var params = {};
      if (this.mine_id > 0) params.mine_agent_id = this.mine_id;
      this.$get('MpWeixin/getWxCfgInfo', params).then(function (res) {
        res = res || {};
        res.mine_agent_id = res.agent_id || _this.agentInfo.id;
        res.encryption_method = res.encryption_method || 'text';
        res.follow_open = res.follow_open || 0;
        _this.form = res;
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var url = 'MpWeixin/saveWxCfg';
      var params = JSON.parse(JSON.stringify(this.form));
      this.$post(url, params).then(function (res) {
        _this2.$message({
          message: '提交成功',
          type: 'success'
        });
        if (_this2.checkRoles(['terminal'])) {
          _this2.$router.push({
            path: '/wx/wxpublic'
          });
        }
      });
    }
  }
};